import { TinyEmitter } from 'tiny-emitter';
import type { TinyEmitterWithInternals } from '@/modules/core/app/helpers/interfaces/TinyEmitterWithInternals';

export class EventBus {
  eventBus: TinyEmitterWithInternals;

  constructor() {
    this.eventBus = new TinyEmitter();
  }

  /**
   * Trigger an event
   */
  signal(name: string, ...args: unknown[]): void {
    this.eventBus.emit(name, ...args);
  }

  /**
   * Listens for an event triggered by EventBus
   * All the arguments are passed on to the callback function
   */
  listen<T>(name: string, callback: (data?: T) => void): void {
    this.eventBus.on(name, callback);
  }

  /**
   * Listen for an event, but only once.
   * The listener will be removed once it triggers for the first time.
   */
  listenOnce(name: string, callback: () => void): void {
    this.eventBus.once(name, callback);
  }

  /**
   * Remove listener(s).
   * If no arguments are provided, remove all event listeners;
   * If only the event is provided, remove all listeners for that event;
   * If both event and callback are given, remove the listener for that specific callback only.
   */
  destroy(name?: string, callback?: () => void): void {
    if (name) {
      this.eventBus.off(name, callback);
      return;
    }

    this.eventBus.e = {};
  }
}

export default new EventBus();
